import UserApi from '@/api/user'
import { getToken, removeToken,setToken } from '@/utils/auth'

const user = {
  state: {
    token: '',
    userInfo: null,
    acctInfo: {},
    permission: [],
    popupLogin:false
  },
  mutations: {
    SET_TOKEN: (state,token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    GET_USER_INFO: (state) => {
      return state.userInfo
    },
    SET_ACCT_INFO: (state, acctInfo) => {
      state.acctInfo = acctInfo
    },
    GET_ACCT_INFO: (state) => {
      return state.acctInfo
    },
    SET_PERMISSION: (state, permission) => {
      state.permission = permission
    },
    GET_PERMISSION: (state) => {
      return state.permission
    },
    SET_POPUPLOGIN: (state,open) => {
      state.popupLogin = open
    }
  },
  actions: {
    getUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        UserApi.userInfo().then((result) => {
          commit('SET_USER_INFO', result.data)
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    setToken ({ commit }, token) {
            commit('SET_TOKEN',token)
            commit('SET_USER_INFO', null)
            setToken(token)
    },
    removeToken({ commit }) {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', null)
        removeToken()
    },
    openPopupLogin({commit},openPopupLogin){
        commit('SET_POPUPLOGIN', openPopupLogin)
    }
  }

}

export default user
